// @flow
import React, { PureComponent, Fragment } from 'react';

import TextInput from 'components/fragments/input/material/TextInputMaterial';
import TextareaInput from 'components/fragments/input/material/TextareaInputMaterial';
import { validateEmail } from 'utils/validatorUtils';
import { getFileNameFromPath } from 'utils/urlUtils';

type Props = {
  jobname: string,
  jobemail: string,
  onSubmit: (formInputs: Object) => void,
  formId: number
};

type State = {
  name: string,
  email: string,
  message: string,
  file: string,
  file2: string,
  errors: Object
};

class JobDetailForm extends PureComponent<Props, State> {
  state: State = {
    name: '',
    email: '',
    message: '',
    file: '',
    file2: '',
    errors: {
      name: '',
      email: '',
      message: ''
    }
  };

  _handleSubmit = (event: Event) => {
    event.preventDefault();
    // @TODO Add submit action
    const { name, email, message } = this.state;
    const { onSubmit, formId } = this.props;

    const input: any = document.querySelector('input[type="file"]#file');
    var documentData: HTMLInputElement = input.files[0];
    const input2: any = document.querySelector('input[type="file"]#file2');
    var documentData2: HTMLInputElement = input2.files[0];

    const data = {
      'postuler-nom': name,
      'postuler-email': email,
      'postuler-message': message,
      'postuler-jobname': this.props.jobname,
      'postuler-contact-file': documentData,
      'postuler-contact-file-2': documentData2,
      'postuler-email-candidature': this.props.jobemail ? this.props.jobemail : 'recrutement@ffr.fr',
      redirection: '/ffr/carriere/offres',
      _wpcf7_unit_tag: formId
    };

    this.setState(prevState => ({
      ...prevState,
      errors: {
        ...prevState.errors,
        file: '',
        file2: ''
      }
    }));

    if (name === '') {
      this.setState(prevState => ({
        ...prevState,
        errors: {
          ...prevState.errors,
          name: 'Ce champ est requis.'
        }
      }));
    }

    if (email === '') {
      this.setState(prevState => ({
        ...prevState,
        errors: {
          ...prevState.errors,
          email: 'Ce champ est requis.'
        }
      }));
    }

    if (!validateEmail(email)) {
      this.setState(prevState => ({
        ...prevState,
        errors: {
          ...prevState.errors,
          email: `L'adresse email renseignée est invalide.`
        }
      }));
    }

    if (
      email !== '' &&
      name !== '' &&
      validateEmail(email) &&
      !this.validateFile(documentData) &&
      !this.validateFile(documentData2)
    ) {
      onSubmit(data);
    }
  };

  validateFile = (documentData: HTMLInputElement) => {
    let error = '';
    if (documentData && documentData.size > 5000000) {
      error = `La taille maximale de fichier autorisée est de 5 Mo.`;
    } else if (documentData && documentData.type !== 'application/pdf') {
      error = `Le type de fichiers autorisé est PDF.`;
    }
    return error;
  };

  setFile = (e: any) => {
    const file = e.target.value;
    const documentData = e.target.files[0];
    const fileerror = this.validateFile(documentData);
    if (fileerror !== '') {
      this.setState({ file: '', errors: { ...this.state.errors, file: fileerror } });
    } else {
      this.setState({ file, errors: { ...this.state.errors, file: fileerror } });
    }
  };

  setFile2 = (e: any) => {
    const file2 = e.target.value;
    const documentData = e.target.files[0];
    const fileerror = this.validateFile(documentData);
    if (fileerror !== '') {
      this.setState({ file2: '', errors: { ...this.state.errors, file2: fileerror } });
    } else {
      this.setState({ file2, errors: { ...this.state.errors, file2: fileerror } });
    }
  };

  _handleChange = (name: string, value: string) => {
    this.setState({ [name]: value });
  };

  render() {
    const { errors } = this.state;

    if (!validateEmail(this.props.jobemail)) {
      return null;
    }

    return (
      <Fragment>
        <div className="separator mt-5 mb-5" />
        <h3 className="mb-1">Je postule</h3>
        <p className="ft-black-secondary mb-3">Envoyez-nous juste quelques informations et nous vous contacterons.</p>
        <form onSubmit={this._handleSubmit}>
          <div className="form-row">
            <TextInput
              id="dhfu732h"
              label="Nom Complet*"
              hasError={errors.name !== ''}
              errorMessage={errors.name}
              onChange={value => this._handleChange('name', value)}
            />
            <TextInput
              id="dhfusdf22h"
              label="Adresse mail *"
              hasError={errors.email !== ''}
              errorMessage={errors.email}
              onChange={value => this._handleChange('email', value)}
            />
          </div>
          <TextareaInput id="dsiuh2" label="Votre message" onChange={value => this._handleChange('message', value)} />
          <div
            className={
              errors.file
                ? 'box box--smoke input--file form-contact__file mb-2 has-error'
                : this.state.file
                ? 'box box--smoke input--file has-file form-contact__file mb-2'
                : 'box box--smoke input--file form-contact__file mb-2'
            }
          >
            <i className="icon icon-pj" />
            <label htmlFor="file">
              {this.state.file !== '' ? (
                <span>{getFileNameFromPath(this.state.file)}</span>
              ) : (
                <Fragment>
                  <span>Ajouter un fichier **</span> ou glissez-le ici
                </Fragment>
              )}
            </label>
            <input id="file" name="inputFile" type="file" onChange={this.setFile} accept="application/pdf" />
          </div>
          {errors.file && <span className="input__error">{errors.file}</span>}
          <div
            className={
              errors.file2
                ? 'box box--smoke input--file form-contact__file has-error mb-2'
                : this.state.file2
                ? 'box box--smoke input--file has-file form-contact__file'
                : 'box box--smoke input--file form-contact__file'
            }
          >
            <i className="icon icon-pj" />
            <label htmlFor="file2">
              {this.state.file2 !== '' ? (
                <span>{getFileNameFromPath(this.state.file2)}</span>
              ) : (
                <Fragment>
                  <span>Ajouter un second fichier **</span> ou glissez-le ici
                </Fragment>
              )}
            </label>
            <input id="file2" name="inputFile2" type="file" onChange={this.setFile2} accept="application/pdf" />
          </div>
          {errors.file2 && <span className="input__error">{errors.file2}</span>}
          <div className="form-action mt-2">
            <div>
              <p className="ft-tertiary ft-black-secondary">* champs obligatoires</p>
              <p className="ft-tertiary ft-black-secondary">** taille max : 5 Mo</p>
            </div>
            <div>
              <button className="btn btn--primary" type="submit">
                Envoyer ma candidature
              </button>
            </div>
          </div>
        </form>
      </Fragment>
    );
  }
}

export default JobDetailForm;
